/**
 * useIsAdmin
 *
 * Returns whether the current user has the admin custom claim (set via Admin SDK).
 * Used to show Template manager and other admin-only UI.
 */

import { useState, useEffect } from 'react';
import { auth } from '@/lib/firebase';

export function useIsAdmin(): { isAdmin: boolean; loading: boolean } {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }
      setLoading(true);
      user
        .getIdTokenResult(true)
        .then((result) => {
          setIsAdmin(result.claims?.admin === true);
        })
        .catch(() => setIsAdmin(false))
        .finally(() => setLoading(false));
    });
    return () => unsubscribe();
  }, []);

  return { isAdmin, loading };
}
